import { GET, POST } from "../../Methods";
import { APIS } from "../../APIS";

export const ClientLogin = async (data) => {
  // try {
  return await POST(APIS.Login, data);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};

export const ClientRegistration = async (data) => {
  // try {
  return await POST(APIS.Registration, data);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};

export const ClientDetails = async () => {
  // try {
  return await GET(APIS.Login);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};

export const ClientChangePassword = async (data) => {
  // try {
  return await POST(APIS.ChangePassword, data);
  // } catch (error) {
  //   console.error(error);
  //   return error;
  // }
};
